export const NavigationSearchType = {
  ADDRESS: "ADDRESS",
  ADDRESS_PLUS_BUSINESS_NAME: "ADDRESS_PLUS_BUSINESS_NAME",
  LAT_LNG: "LAT_LNG",
  CLIPBOARD_ADDRESS: "CLIPBOARD_ADDRESS",
  CLIPBOARD_ADDRESS_PLUS_BUSINESS_NAME: "CLIPBOARD_ADDRESS_PLUS_BUSINESS_NAME",
} as const;

export type NavigationSearchType =
  (typeof NavigationSearchType)[keyof typeof NavigationSearchType];
